import { render } from "./UserRallyPreferences.vue?vue&type=template&id=6195f918"
import script from "./UserRallyPreferences.vue?vue&type=script&lang=js"
export * from "./UserRallyPreferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__